import React, { useState, useEffect } from 'react'
import { InputGroup, Button, Icon, ButtonGroup } from '@blueprintjs/core'
import { useParams } from 'react-router-dom'
import { AppToaster } from '../../../../utilities/Toaster/Toaster'

const DestinationRangeInput = ({ trigger, sheetId, taskId, callback, checkChangesDestinationRange, setCheckChangesDestinationRange, selectedTrigger, setSelectedTrigger, selectedTriggerIndex, setSelectedTriggerIndex }) => {

    const [prevTrigger, setPrevTrigger] = useState(trigger)
    const params = useParams()
    const [isLoad, setIsLoad] = useState(false)
    const [isEditing, setIsEditing] = useState(false)

    useEffect(() => {
        setPrevTrigger(trigger)
    }, [trigger])

    const checkValueChanges = (temp) => {
        if(trigger.destinationRange !== temp) {
            setCheckChangesDestinationRange(true)
            setSelectedTrigger(trigger)
        } else {
            setCheckChangesDestinationRange(false)
        }
    }

    const handleEditDestinationRange = (event) => {
        setIsEditing(true)
        setSelectedTriggerIndex(selectedTriggerIndex)
        setPrevTrigger(prev => ({ ...prev, destinationRange: event.target.value }))
        checkValueChanges(event.target.value)
    }

    const isValidExcelCellRange = (cellRange) => {
        // console.log(`Trigger Source Tag: ${trigger.source.tag}`)
        // if (trigger.source.tag !== 'FM') {
        //     var pattern = /^([A-Za-z]{1,3}\d+)|([A-Za-z]{1,3}\d+:[A-Za-z]{1,3}\d+)|([A-Za-z]{1,3}:[A-Za-z]{1,3})$/
        //     console.log(`Cell Range: ${cellRange}`)
        //     console.log(`Pattern Test (Cell Range): ${pattern.test(cellRange)}`)
        //     return pattern.test(cellRange)
        // } else {
        //     return true
        // }

        return true
    }

    const handleSubmitEdit = () => {
        setIsLoad(true)
        if(isValidExcelCellRange(prevTrigger.destinationRange)) {
            fetch('/api/jobs/updateTrigger', { 
                method: 'PUT', 
                body: JSON.stringify({ 
                    bookId: params.id, 
                    sheetId: sheetId, 
                    taskId: taskId, 
                    triggerId: prevTrigger.triggerId, 
                    triggerData: {
                        triggerName: prevTrigger.triggerName,
                        triggerDescription: prevTrigger.triggerDescription,
                        status: prevTrigger.status,
                        rank: prevTrigger.rank,
                        source: prevTrigger.source,
                        sourceRange: prevTrigger.sourceRange,
                        destinationRange: prevTrigger.destinationRange,
                        isEnable: prevTrigger.isEnable,
                    }
                }), 
                headers: { 'Content-Type': 'application/json' } 
            })
                .then(res => res.json())
                .then(data => {
                    callback()
                    setIsLoad(false)
                    setCheckChangesDestinationRange(false)
                    setIsEditing(false)
                })
        } else {
            setIsLoad(false)
            setIsEditing(false)
            AppToaster.show({ icon: 'info-sign', intent: 'danger', message: 'Invalid Cell Range!' })
        }
    }

    const handleCancelEdit = () => {
        setTimeout(() => {
            setPrevTrigger(prev => ({ ...prev, destinationRange: trigger.destinationRange }))
            setCheckChangesDestinationRange(false)
        }, 200)
        setIsEditing(false)
    }

    return (
        <InputGroup
            intent='none'
            style={{ fontSize: '13px', borderLeft: '3px solid #2D72D2' }}
            fill={true}
            small={false}
            value={prevTrigger.destinationRange}
            onChange={handleEditDestinationRange}
            disabled={!prevTrigger.isEnable || (prevTrigger.triggerName === 'Copy' || prevTrigger.triggerName === 'Clear')}
            onBlur={isEditing ? handleCancelEdit : null}
            leftElement={<Icon icon='list-detail-view'/>}
            onKeyPress={e => e.key === 'Enter' ? handleSubmitEdit() : '' }
            rightElement={
                checkChangesDestinationRange && selectedTrigger.triggerId === prevTrigger.triggerId ?
                <ButtonGroup>
                    <Button className='check-hover' icon='small-tick' intent='success'
                        onClick={handleSubmitEdit}
                        disabled={!trigger.isEnable}
                        loading={isLoad}
                    ></Button>
                    <Button icon='cross-circle' intent='danger'
                        onClick={handleCancelEdit}
                    ></Button>
                </ButtonGroup> : null
            }
        ></InputGroup>
    )
}

export default DestinationRangeInput